import { Inject, Injectable } from "@angular/core";
import { NmsTableValidatorService, RowsValidateModel } from "@nms-angular-toolkit/nms-table";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";

/**
 * Serviço responsável por realizar as validações referentes aos Mux/Demux.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmMuxDemuxValidationService {
    constructor(private readonly nmsTableValidatorService: NmsTableValidatorService,
        @Inject(ANGULARJS_TRANSLATE) private readonly translate: any
    ) {}

    /**
     * Verifica se atende as condições para edição de um Mux:
     *  - verifica se possui linha selecionada;
     *  - verifica se é permitido selecionar múltiplas linhas.
     * @param rowsSelected: Quantidade de linhas selecionadas.
     * @param multipleRows: booleano no qual indica se é permitido selecionar múltiplas linhas
     * @returns boolean
     */
    public isValidForEdit(rowsSelected: number, multipleRows: boolean): boolean {
        const rowsSelectedModel = this.buildRowsValidationModel(
            this.translate.instant("mux.table.no.item.selected"), rowsSelected, multipleRows);
        const multipleRowsModel = this.buildRowsValidationModel(
            this.translate.instant("mux.table.select.one.item"), rowsSelected, multipleRows);

        return this.nmsTableValidatorService.hasRowSelected(rowsSelectedModel) &&
            this.nmsTableValidatorService.allowMultipleRowsSelected(multipleRowsModel);
    }

    isValidForRemove(rowsSelected: number): boolean {
        const allowMultipleRowsSelected = true;
        const rowsSelectedModel = this.buildRowsValidationModel(
            this.translate.instant("mux.table.no.item.selected"), rowsSelected, allowMultipleRowsSelected);

        return this.nmsTableValidatorService.hasRowSelected(rowsSelectedModel);
    }

    /**
     * Prepara o modelo para validar os itens selecionados na tabela.
     * @param message: Mensagem a ser exibida caso a validação falhe.
     * @param rowsSelected: Quantidade de linhas selecionadas.
     * @param allowMultipleSelection: verificar se permite ou não selecionar múltiplas linhas, o default é false.
     * @returns
     */
    private buildRowsValidationModel(message: string, rowsSelected: number, allowMultipleSelection = false): RowsValidateModel {
        return {
            rowsSelected,
            message,
            allowMultipleSelection
        };
    }
}
